(function(){
  function init(){
    var more = document.getElementById('whr-more');
    if (more && !more.dataset.wh) {
      more.dataset.wh = '1';
      more.addEventListener('click', function(){
        var h = document.querySelectorAll('#whr-grid .whr-h');
        for (var i = 0; i < 6 && i < h.length; i++) h[i].classList.remove('whr-h');
        var left = document.querySelectorAll('#whr-grid .whr-h').length;
        if (left) { more.textContent = more.textContent.replace(/\(\d+\)/, '(' + left + ')'); }
        else { more.remove(); }
      });
    }
    var t = document.getElementById('whr-toggle');
    var f = document.getElementById('whr-form');
    if (t && f && !t.dataset.wh) {
      t.dataset.wh = '1';
      t.addEventListener('click', function(){
        var open = f.style.display === 'block';
        f.style.display = open ? 'none' : 'block';
        if (!open) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    var st = document.getElementById('whr-stars');
    if (st && !st.dataset.wh) {
      st.dataset.wh = '1';
      st.addEventListener('click', function(e){
        var v = e.target.getAttribute('data-v');
        if (!v) return;
        document.getElementById('whr-rate').value = v + ' of 5 stars';
        for (var i = 0; i < 5; i++) st.children[i].style.opacity = i < v ? '1' : '.3';
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
